module.exports = __webpack_public_path__ + "static/WEDDING E&M-20-5d87802d9ae745ebc3f8d1803e851366.jpg";